<template>
  <radio :value="true" :modelValue="storeAnswer.checked" :disabled="disabled" main-class="inline-flex" />
</template>
<script>
import mixin from './_mixin_display_base'
import radio from '../_radio.vue';
import {EmptyAnswer} from './_mixin_display_base';

export default {
  components: {radio},
  mixins: [mixin],
  props: {
    statement: {},
    value: {},
    disabled: {type: Boolean, required: false, default: false},
  },
  computed: {
    storeAnswer(){
      return this.formResultStore.answersByFieldAndOption(this.field.id, this.statement.option_id).find(a=>a.likert_id === this.value.column_id) || EmptyAnswer
    },
  },
}
</script>